import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const en = require("./locales/en/translation.json");
// eslint-disable-next-line @typescript-eslint/no-var-requires
const bn = require("./locales/bn/translation.json");

const urlLang = new URLSearchParams(window.location.search).get("lang");
const supportedLangs = ["en", "bn"];
const activeLang =
  (urlLang && supportedLangs.includes(urlLang) ? urlLang : null) ||
  localStorage.getItem("lang") ||
  "en";

if (urlLang && supportedLangs.includes(urlLang)) {
  localStorage.setItem("lang", urlLang);
}

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    bn: { translation: bn },
  },
  lng: activeLang,
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export default i18n;
